import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import {
  createRecipePersonalNoteAction,
  updateRecipePersonalNoteAction,
  getRecipePersonalNoteAction,
  deleteRecipePersonalNoteAction,
} from "./actions";

interface PersonalNote {
  user_id: string;
  recipe_id: string;
  personal_note: string;
}

const initialRecipePersonalNote: PersonalNote = {
  user_id: "",
  recipe_id: "",
  personal_note: "",
};

const RecipePersonalNoteSlice = createSlice({
  name: "RecipePersonalNoteSlice",
  initialState: initialRecipePersonalNote,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(createRecipePersonalNoteAction.fulfilled, (state) => {});
    builder.addCase(updateRecipePersonalNoteAction.fulfilled,(state) => {});
    builder.addCase(getRecipePersonalNoteAction.fulfilled, (state) => {});
    builder.addCase(deleteRecipePersonalNoteAction.fulfilled,  (state) => {} );
  },
});

export const recipePersonalNoteSlice = RecipePersonalNoteSlice.reducer;